function toCurrencyFormatter(value: number) {
  if (typeof value !== 'number') {
      return value;
  }
  const formatter: Intl.NumberFormat = new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: 2
  });
  return formatter.format(value);
}

export default toCurrencyFormatter;
